import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Breadcrumbs from "@/components/Breadcrumbs";
import { useUser } from "@/hooks/useUser";
import { useRefreshOnVisibility } from "@/hooks/useRefreshOnVisibility";
import { Skeleton } from "@/components/ui/skeleton";

export default function InternalLayout() {
  const navigate = useNavigate();
  const { user, isLoading, isAuthenticated } = useUser();
  const [authorized, setAuthorized] = useState(false);

  useRefreshOnVisibility({
    thresholdMinutes: 60,
    onExpire: () => {
      window.location.reload();
    },
  });

  useEffect(() => {
    if (isAuthenticated && user) {
      if (user.user_type === "INTERNAL") {
        setAuthorized(true);
        return;
      } else {
        navigate("/not-found");
      }
    }
  }, [isAuthenticated, user, navigate]);

  if (isLoading || !isAuthenticated || !user) {
    return (
      <div className="container mx-auto p-4 space-y-4">
        <Skeleton className="h-[60px] w-full" />
        <Skeleton className="h-[400px] w-full" />
        <Skeleton className="h-[200px] w-full" />
      </div>
    );
  }

  if (!authorized) {
    return null;
  }

  return (
    <>
      <Header />
      <Breadcrumbs />
      <main className="min-h-[calc(100vh-128px)]">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
